export class OrderRefundError {
  public code!: string;
  public translationKey!: string;

  constructor(data: any = {}) {
    Object.assign(this, data);
  }
}

export const LIST_ORDER_REFUND_ERROR: any = {
  TRANSPORT_NOT_BILLED: new OrderRefundError({ code: 'TRANSPORT_NOT_BILLED', translationKey: '' }),
  REFUND_REFUSED_WITH_METHOD_PAYMENT: new OrderRefundError({
    code: 'REFUND_REFUSED_WITH_METHOD_PAYMENT',
    translationKey: '',
  }),
  REFUND_REFUSED_BECAUSE_VIRTUAL_CARD: new OrderRefundError({
    code: 'REFUND_REFUSED_BECAUSE_VIRTUAL_CARD',
    translationKey: '',
  }),
  REFUND_REFUSED_BECAUSE_NOT_REMAINING: new OrderRefundError({
    code: 'REFUND_REFUSED_BECAUSE_NOT_REMAINING',
    translationKey: '',
  }),
  TOTALLY_REFUND: new OrderRefundError({ code: 'TOTALLY_REFUND', translationKey: '' }),
  NO_RIGHT_FOR_REFUND: new OrderRefundError({ code: 'NO_RIGHT_FOR_REFUND', translationKey: '' }),
  NO_AUTHORITY_FOR_REFUND: new OrderRefundError({ code: 'NO_AUTHORITY_FOR_REFUND', translationKey: '' }),
  NO_ACTIVATION_FOR_REFUND: new OrderRefundError({ code: 'NO_ACTIVATION_FOR_REFUND', translationKey: '' }),
  NO_UUID_PRESENT: new OrderRefundError({ code: 'NO_UUID_PRESENT', translationKey: '' }),
  INIT_VIR_CANNOT_BE_REFUND: new OrderRefundError({ code: 'INIT_VIR_CANNOT_BE_REFUND', translationKey: '' }),
};
